import React, { useRef } from 'react';
import { useState } from 'react';
import styles from './app.module.css';
import { useForm } from 'react-hook-form';
import signInFirebase from '../../../services/firebase_auth';
import LOGO from '../../../assets/svgs/varianti_logo.svg';

export default function SignInPage() {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    if (loading) return;
    signInFirebase({
      email: data.email,
      password: data.password,
      setLoading: setLoading,
      errorCallback: setErrorMsg
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.middleContainer}>
        <img src={LOGO} alt="" style={{ width: 100, margin: 100, marginTop: 200, marginBottom: 20 }} />
        {/* <h2 className={styles.logoText}>Admin panel</h2> */}
        {/* Login Form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className={styles.formLable}>ელ.ფოსტა</label>
            <input
              ref={emailRef}
              type="email"
              className="form-control"
              placeholder="example@gmail.com"
              {...register('email', {
                required: 'Required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'invalid email address',
                },
              })}
            />
            {errors.email && <p>{errors.email.message}</p>}
          </div>
          <div className="form-group">
            <label className={styles.formLable}>პაროლი</label>
            <input
              ref={passwordRef}
              type="password"
              className="form-control"
              placeholder="Password"
              {...register('password', {
                required: 'Required',
              })}
            />
          </div>
          <div className="form-check">
            {errorMsg && <label>{errorMsg}</label>}
          </div>
          <button type="submit" className="btn btn-primary">
            შესვლა
          </button>
        </form>
        {/*  */}
      </div>
    </div>
  );
}
